var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChannel = function SvgChannel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M8 16c0 2 1.183 4 3.13 4 3.826 0 5.914-8 9.74-8C24 12 24 16 24 16"
  })));
};
export { SvgChannel as ReactComponent };
export default "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M8 16C8 18 9.18261 20 11.1304 20C14.9565 20 17.0435 12 20.8696 12C24 12 24 16 24 16' stroke='%234A6067' stroke-width='2'/%3e %3c/svg%3e";